export default "__VITE_ASSET__ffbf2535__"